import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
// import { Link } from 'react-router'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { Title, HeaderPlain } from 'components/layout'
import { logout } from 'redux/modules/auth'
import { getToken } from 'utils/token'

import config from 'config'

@connect(
  ({ auth }) => ({
    user: auth.user,
    loginPageCode: auth.loginPageCode
  }),
  {
    logout
  }
)
class LogoutInactive extends Component {
  static propTypes = {
    logout: PropTypes.func,
    location: PropTypes.object,
    user: PropTypes.object,
    loginPageCode: PropTypes.string
  }

  componentDidMount = () => {
    const { user } = this.props

    if (getToken(user)) {
      this.props.logout()
    }
  }

  render() {
    const { location, loginPageCode } = this.props

    return (
      <div>
        <HeaderPlain />
        <div className="container">
          <div style={{ paddingTop: 10 }} className="text--center">
            <Title
              h1
              intlKey={
                get(location, 'state.reasonIntlKey') ||
                'moduleTitle.you_have_been_logged_out_due_to_inactivity'
              }
            >
              {get(location, 'state.reason') ||
                'You have been logged out due to inactivity'}
            </Title>
            <a className="btn" href={loginPageCode ? `${config.foInternalUrl}/${loginPageCode}` : config.foInternalUrl} target="_self">
              <FormattedMessage id="button.login" defaultMessage="Login" />
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default LogoutInactive
